import React from 'react';

import './App.css';
import './change-colors.css';

import 'devextreme/dist/css/dx.material.blue.light.compact.css';

import { locale, loadMessages } from 'devextreme/localization';
import esMessages from 'devextreme/localization/messages/es.json';

import {
    BrowserRouter as Router,
    Routes, Route, Navigate
} from 'react-router-dom';

import {routes} from './Config/routes';
import {AuthProvider, useAuthState} from './Context/AuthProvider/AuthProvider';
import Moment from 'react-moment';
import 'moment/locale/es';
import {AlertProvider} from './Context/AlertProvider/AlertProvider';
import {ResponseFetchInterceptor} from './Context/ResponseFetchInterceptor';

import {licenseKey} from './devextreme-license';
import {config} from 'devextreme/common';

import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';

import {Auth0Provider, useAuth0} from '@auth0/auth0-react';
import {LayoutProvider} from './Context/LayoutProvider/LayoutProvider';


loadMessages(esMessages);
locale('es');

config({licenseKey: licenseKey});

Moment.globalLocale = 'es';

const AppRoutes:React.FunctionComponent = (_props) => {
    const user = useAuthState();

    const {getAccessTokenSilently} = useAuth0();

    const checkSession = React.useCallback( async () => {
        try {
            await getAccessTokenSilently({
                cacheMode: 'off'
        });
            console.log('Session .');
        } catch (error : unknown) {
            if (
                error &&
                typeof error === 'object' &&
                'error' in error &&
                (error as { error: string }).error === 'login_required'
            ) {
                console.log('Session -');
            } else {
                console.error('Session --', error);
            }

        }
    }, [getAccessTokenSilently] );

    React.useEffect ( ()=>{
        checkSession().then();

        const intervalId = setInterval(()=>{
            checkSession().then();
        }, 5 * 60 * 1000);
        return () => clearInterval(intervalId);
    }, [checkSession]);

    return (
        <Router>
            <Routes>
                { routes.map( (props ) =>
                    <Route
                        key={props.path}
                        path={props.path}
                        element={( !props.isPrivate || Boolean(user.token) ) ? <props.component /> : <Navigate to="/login" replace />}
                    />
                ) }
            </Routes>
        </Router>
    );
};

export const App: React.FunctionComponent = (_props) => {
    React.useEffect( ()=>{
        const el = document.querySelector('.loader-container');
        if (el) {
            el.remove();
        }
    }, [] );

    return (
        <ConfigProvider locale={esES}>
          <AuthProvider>
              <Auth0Provider
                  domain="diazar.us.auth0.com"
                  clientId="2WmaYM4F3DX9GndrPeAEPNbPQmTbMVQR"
                  authorizationParams={{
                      redirect_uri: window.location.origin + '/auth/callback'
                  }}
                  onRedirectCallback={(appState) => {
                      if (appState?.company) {
                          sessionStorage.setItem('company_tmp', appState.company);
                      }
                      if (appState?.action) {
                          sessionStorage.setItem('action_tmp', appState.action);
                      }
                  }}
              >
                  <AlertProvider>
                      <ResponseFetchInterceptor>
                          <LayoutProvider>
                              <AppRoutes />
                          </LayoutProvider>
                      </ResponseFetchInterceptor>
                  </AlertProvider>
              </Auth0Provider>
          </AuthProvider>
        </ConfigProvider>
    );
};
